import { AfterContentInit, ChangeDetectorRef, Component, ContentChildren, EventEmitter, inject, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges } from '@angular/core';
import { TabComponent } from './tab/tab.component';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
    selector: 'ig-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements AfterContentInit, OnChanges, OnInit {
  @Input() background = false;
  @Input() selectedTab = 0;
  @Input() noMargin = false;
  @Output() selectedTabChange = new EventEmitter<any>();

  @ContentChildren(TabComponent) tabs?: QueryList<TabComponent>;

  readonly #router = inject(Router);
  private tabsArray: TabComponent[] = [];

  constructor(private readonly ref: ChangeDetectorRef) { }

  onSelectTab(tab: TabComponent) {
    if (tab.disabled) {
      return;
    }
    this.reset();
    tab.active = true;

    if (tab.tabRouterLink) {
      this.#router.navigate(_.isString(tab.tabRouterLink) ? tab.tabRouterLink.split('/') : tab.tabRouterLink);
    }

    this.tabsArray = this.tabs?.toArray() || [];
    this.selectedTab = this.tabsArray.findIndex(tab => tab.active);

    this.selectedTabChange.emit(this.selectedTab);
  }

  ngOnInit() {
    this.ref.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.reset();

    if (changes['selectedTab']) {
      this.selectActiveTab();
    }
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.selectActiveTab();

      const activeTab = this.tabs?.filter(tab => tab.active);

      if (activeTab?.length === 0) {
        if (this.tabs?.first) {
          this.tabs.first.active = true;
        }
        this.selectedTab = 0;
      }

      this.ref.markForCheck();
    }, 0);
  }

  private selectActiveTab() {
    if (this.tabs) {
      this.tabsArray = this.tabs.toArray();

      const activeTabIndex = this.tabsArray.findIndex(x => x.active);
      if (activeTabIndex !== -1) {
        this.selectedTab = activeTabIndex;
      }

      if (this.tabsArray[this.selectedTab]) {
        this.tabsArray[this.selectedTab].active = true;
      }
    }

    this.ref.markForCheck();
  }

  private reset() {
    this.tabsArray.map(tab => (tab.active = false));

    this.ref.markForCheck();
  }
}
